<template>
  <div
    :style="`width:${width}px;height:${height}px;`"
    style="position: relative; font-size: 22px; cursor: pointer"
    id="pupilxy-content"
  >
    <div v-if="coordinateSystem === 'rectangular'" class="label-info">
      xc: {{ xc.x }} mm yc: {{ yc.y }} mm
    </div>
    <div v-if="coordinateSystem === 'polar'" class="label-info">
      R: {{ xc.r }} mm θ: {{ yc.angle }}°
    </div>
    <div class="label-y">yc [mm]</div>
    <div class="label-x">xc [mm]</div>
    <canvas
      ref="pupilxy"
      :width="width"
      :height="height"
      style="background-color: #1b1d23"
    ></canvas>
  </div>
</template>

<script>
const colors = {
  background: "#1b1d23",
  grid: "#333",
  circle: "#444",
  axis: "#666",
  text: "#ccc",
  line: "#f00"
};

export default {
  name: "PupilConeaXy",
  props: {
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    },
    pupilCenterX: {
      type: Array,
      default: () => {
        return [];
      }
    },
    pupilCenterY: {
      type: Array,
      default: () => {
        return [];
      }
    },
    ringCenterX: {
      type: Array,
      default: () => {
        return [];
      }
    },
    ringCenterY: {
      type: Array,
      default: () => {
        return [];
      }
    },
    coordinateSystem: {
      type: String,
      default: "rectangular"
    }
  },
  computed: {
    centerX() {
      return this.width / 2;
    },
    centerY() {
      return this.height / 2;
    },
    radius() {
      return Math.min(this.width, this.height) / 2;
    }
  },
  data() {
    return {
      ctx: null,
      resData: [],
      xc: {
        x: "--",
        r: "--"
      },
      yc: {
        y: "--",
        angle: "--"
      },
      pupilCalIndex: 0
    };
  },
  methods: {
    cartesianToPolar(x, y) {
      if (x === "--" || y === "--" || x === -1000 || y === -1000) {
        return {
          radius: "--",
          angle: "--", // 弧度
          angleDegrees: "--" // 度数
        };
      }
      // 计算半径 R
      const radius = Math.sqrt(x * x + y * y);
      // 计算角度 θ（弧度）
      let angle = Math.atan2(y, x);

      if (angle < 0) {
        angle += 2 * Math.PI;
      }

      // 如果需要角度（度数）
      const angleDegrees = angle * (180 / Math.PI);
      // 返回极坐标（半径和角度）
      return {
        radius: radius.toFixed(2),
        angle: angle, // 弧度
        angleDegrees: angleDegrees.toFixed(0) // 度数
      };
    },
    drawCircles() {
      if (!this.ctx) return;

      this.ctx.strokeStyle = colors.circle;
      this.ctx.lineWidth = 2;

      for (let i = 1; i <= 3; i++) {
        this.ctx.beginPath();
        this.ctx.arc(this.centerX, this.centerY, i * (this.radius / 3), 0, Math.PI * 2);
        this.ctx.stroke();
      }
    },
    drawAxes() {
      if (!this.ctx) return;

      this.ctx.strokeStyle = colors.axis;
      this.ctx.lineWidth = 2;

      this.ctx.beginPath();
      this.ctx.moveTo(0, this.centerY);
      this.ctx.lineTo(this.width, this.centerY);
      this.ctx.stroke();

      this.ctx.beginPath();
      this.ctx.moveTo(this.centerX, 0);
      this.ctx.lineTo(this.centerX, this.height);
      this.ctx.stroke();
    },
    drawUnitLabel() {
      if (!this.ctx) return;

      this.ctx.strokeStyle = colors.text;
      this.ctx.lineWidth = 1;

      const startX = 10;
      const startY = this.height - 20;

      this.ctx.beginPath();
      this.ctx.moveTo(startX, startY);
      this.ctx.lineTo(startX, startY - 5);
      this.ctx.moveTo(startX, startY);
      this.ctx.lineTo(startX + this.radius / 3, startY);
      this.ctx.lineTo(startX + this.radius / 3, startY - 5);

      this.ctx.font = "16px Arial";
      this.ctx.fillStyle = "#FFF";
      this.ctx.textAlign = "left";
      this.ctx.textBaseline = "top";

      this.ctx.fillText("0.2", startX + this.radius / 3 + 10, startY - 10);
      this.ctx.stroke();
    },
    drawLine(data) {
      if (!this.ctx) return;

      // 清空容器中的所有之前绘制的点
      const container = document.getElementById("pupilxy-content");
      const previousPoints = container.querySelectorAll('[class*="data-point"]');
      previousPoints.forEach((point) => point.remove());

      this.ctx.strokeStyle = colors.line;
      this.ctx.lineWidth = 1.5;
      this.ctx.beginPath();
      let isLineStarted = false;

      for (let i = 0; i < data.length; i++) {
        if (data[i].xc !== null && data[i].yc !== null) {
          if (Math.abs(data[i].xc) > 0.6 || Math.abs(data[i].yc) > 0.6) {
            continue;
          }
          const x = this.centerX + (data[i].xc * (this.radius / 3)) / 0.2;
          const y = this.centerY - (data[i].yc * (this.radius / 3)) / 0.2;
          if (!isLineStarted) {
            // this.ctx.moveTo(x, y);
            isLineStarted = true;
          } else {
            // this.ctx.lineTo(x, y);
          }
          // 创建白色点的 div 标签
          const pointDiv = document.createElement("div");
          pointDiv.classList.add(`data-point-${i}`);
          pointDiv.style.position = "absolute";
          pointDiv.style.width = "5px";
          pointDiv.style.height = "5px";
          pointDiv.style.backgroundColor = colors.line;
          pointDiv.style.borderRadius = "50%";
          pointDiv.style.left = `${x - 2.5}px`; // 调整以中心对齐
          pointDiv.style.top = `${y - 2.5}px`; // 调整以中心对齐
          pointDiv.style.pointerEvents = "auto"; // 使其能够响应鼠标事件
          pointDiv.style.transition = "transform 0.2s, background-color 0.2s"; // 添加动画效果

          pointDiv.addEventListener("mousemove", () => {
            if (i === this.pupilCalIndex) {
              pointDiv.style.backgroundColor = "#ffeb3b";
              pointDiv.style.transform = "scale(1.5)";
            } else {
              pointDiv.style.backgroundColor = "#fff";
              pointDiv.style.transform = "scale(1.5)";
            }
            let x = Number(data[i].xc).toFixed(2);
            let y = Number(data[i].yc).toFixed(2);
            this.xc = {
              x: x,
              r: this.cartesianToPolar(x, y).radius
            };
            this.yc = {
              y: y,
              angle: this.cartesianToPolar(x, y).angleDegrees
            };
          });

          pointDiv.addEventListener("mouseleave", () => {
            if (i === this.pupilCalIndex) {
              pointDiv.style.backgroundColor = "#ffeb3b";
              pointDiv.style.transform = "scale(1.2)";
            } else {
              pointDiv.style.backgroundColor = colors.line;
              pointDiv.style.transform = "scale(1)";
            }
            let x = Number(data[this.pupilCalIndex].xc).toFixed(2);
            let y = Number(data[this.pupilCalIndex].yc).toFixed(2);
            this.xc = {
              x: x,
              r: this.cartesianToPolar(x, y).radius
            };
            this.yc = {
              y: y,
              angle: this.cartesianToPolar(x, y).angleDegrees
            };
          });

          document.getElementById("pupilxy-content").appendChild(pointDiv);
        } else {
          isLineStarted = false;
        }
      }
      this.ctx.stroke();
    },
    drawPupilDot() {
      if (!this.ctx) return;
      const container = document.getElementById("pupilxy-content");

      const previousPoints = container.querySelectorAll('[class*="data-point"]');

      let x = Number(this.resData[this.pupilCalIndex].xc).toFixed(2);
      let y = Number(this.resData[this.pupilCalIndex].yc).toFixed(2);
      this.xc = {
        x: x,
        r: this.cartesianToPolar(x, y).radius
      };
      this.yc = {
        y: y,
        angle: this.cartesianToPolar(x, y).angleDegrees
      };

      previousPoints.forEach((el) => {
        const classNames = el.className.split(" ");
        const match = classNames[0].match(/data-point-(\d+)$/);
        const index = Number(match[1]);
        if (index === this.pupilCalIndex) {
          el.style.backgroundColor = "#ffeb3b";
          el.style.transform = "scale(1.2)";
          el.style.zIndex = 900;
        } else {
          el.style.backgroundColor = colors.line;
          el.style.transform = "scale(1)";
          el.style.zIndex = 0;
        }
      });
    },
    init(data) {
      this.ctx = this.$refs.pupilxy.getContext("2d");
      this.ctx.clearRect(0, 0, this.width, this.height);
      this.drawCircles();
      this.drawAxes();
      this.drawUnitLabel();
      this.drawLine(data);
    },
    parseData(pupilCenterX, pupilCenterY, ringCenterX, ringCenterY) {
      const res = [];
      if (pupilCenterX.length === 0) {
        return res;
      }
      for (let i = 0; i < pupilCenterX.length; i++) {
        res.push({
          xc:
            pupilCenterX[i] === -1000 || ringCenterX[i] === -1000
              ? null
              : (pupilCenterX[i] - ringCenterX[i]) * 2 * window.magecoe.pupilcornea,
          yc:
            pupilCenterY[i] === -1000 || ringCenterY[i] === -1000
              ? null
              : (pupilCenterY[i] - ringCenterY[i]) * 2 * window.magecoe.pupilcornea
        });
      }
      return res;
    }
  },

  mounted() {
    const resData = this.parseData(
      this.pupilCenterX,
      this.pupilCenterY,
      this.ringCenterX,
      this.ringCenterY
    );
    this.init(resData);
    this.resData = resData;
    this.$bus.$on("PUPILCALINDEX", (index) => {
      this.pupilCalIndex = index;
      this.drawPupilDot();
    });

    this.$bus.$on("PUPILXYCHANGE", () => {
      const resData = this.parseData(
        this.pupilCenterX,
        this.pupilCenterY,
        this.ringCenterX,
        this.ringCenterY
      );
      this.init(resData);
      this.resData = resData;
    });

    // this.drawPupilDot()
    this.$bus.$emit("PUPILT1T2INDEXF");
  },

  destroyed() {
    this.$bus.$off("PUPILCALINDEX");
    this.$bus.$off("PUPILXYCHANGE");
  }
};
</script>

<style lang="less" scoped>
.label-y {
  position: absolute;
  top: 50%;
  left: -60px;
  transform: translateY(-50%) rotate(-90deg);
}

.label-x {
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
}

.label-info {
  position: absolute;
  top: 10px;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/PupilConeaXY.vue